module.exports = __webpack_public_path__ + "img/p4_bg.6ad01a97.jpg";